export { Collapse } from "@mantine/core";
export type { CollapseProps } from "@mantine/core";
